import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import EmployeeModule from './admin/EmployeeModule';

import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import { MenuList, MenuItem } from 'material-ui/Menu';

import Reboot from 'material-ui/Reboot';
import 'typeface-roboto';

import logo from './logo.svg';
import Paper from 'material-ui/Paper/Paper';
import TouchAppIcon from 'material-ui-icons/TouchApp';
import Input from 'material-ui/Input';
import TextField from 'material-ui/TextField';
import { ajaxPost } from './ajax';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import { CircularProgress } from 'material-ui/Progress';
import green from 'material-ui/colors/green';

const { URL, URLSearchParams } = require('url');

var btoa = require('btoa');

const styles = theme => ({
    page: {
        margin: 0,
        width: "100%",
        height: "100%",
        position: "absolute",
       // background: "url('bg.png') no-repeat",
    },
    container: {
        //display: "table-row",
        verticalAlign: "middle",
    },
    textField: {
        //display: "block",
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginTop: 9,
        width: 300,
    },
    form:
        {
            //display: "flex",
            //height: 220,
        margin: "auto",
        },
    main:
        {
            position: "absolute",
            display: "table",
            width: 300,
            height: 600,
            top: "50%",
            left: "50%",
            marginLeft: -165,
            marginTop: -200,
        },
    section:
        {
            width: "100%",
            height: "100%",
            padding: 5,
        },
    logo:
        {
            width: 200,
            height: 100,
            marginTop: -10,
            marginLeft: 55,
        },
    button:
        {
            width: 300,
        },
    message:
        {
            marginTop: 20,
            verticalAlign: "middle",
        },
    fabProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -14,
        marginLeft: -20,
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
        marginTop: 25,
        width: 300,
    },
});

class Login extends Component {
    state =
        {
            username: '',
            password: '',
            error: '',
            validating: false
        }

    handleLogin = () => {
        var _this2 = this;

        var { username, password } = this.state;
        this.setState({ error: '' });
        if (username.trim() === '') {
            this.setState({ error: 'Please input your username' });
            return;
        }
        this.setState({ validating: true });
        ajaxPost(
            {
                url: '/UserAPI/Login',
                credentials: 'include',
                data:
                    {
                        Pair: btoa(username + "|" + password),
                        Params: this.props.redirect != null ? this.props.redirect : "",
                    },
                onError: () => { },
                onSuccess: data => {
                    if (data == null) {
                        _this2.setState({ error: 'Invalid username or password' });
                    }
                    else {
                        var bAllow = true;
                        var redirect = _this2.props.redirect;

                        if (redirect != null) {
                            if (data.RoleCode == "USER" && _this2.props.redirect == "monitor")
                                bAllow = false;
                        }
                        else {
                            redirect = "main";
                        }

                        if (bAllow)
                            window.location = redirect;
                        else
                            _this2.setState({ error: 'You dont have access rights to use this feature' });
                    }
                },
                finally: () => {
                    this.setState({ validating: false });
                }
            }
        )
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handlePress = event => {
        if (event.key == 'Enter')
            setTimeout(() => {
                this.handleLogin();
            }, 0)
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.page}> 
                <img src='bg.png' className={classes.page} />
                <div className={classes.main}>
                    <Reboot />
                    <div className={classes.container}>
                        <div className={classes.form}>
                            <div className={classes.section}>
                                <img src='logo.png' className={classes.logo} />
                            </div>
                            <div className={classes.section}>
                                <TextField name="username" value={this.state.username} placeholder="Username" className={classes.textField} onChange={this.handleChange.bind(this)} />
                                <TextField name="password" value={this.state.password}
                                    placeholder="Password" className={classes.textField}
                                    type="password"
                                    onChange={this.handleChange.bind(this)}
                                    onKeyPress={this.handlePress.bind(this)}
                                />
                                <div className={classes.wrapper}>
                                    <Button style={{"background":"#2574bb","color":"#fff"}} disabled={this.state.validating} raised color="primary" className={classes.button} onClick={this.handleLogin.bind(this)}>Login</Button>
                                    {this.state.validating && <CircularProgress size={30} className={classes.fabProgress} />}
                                </div>
                                <Typography color="error" className={classes.message}>{this.state.error}</Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/login.js